import * as Sentry from '@sentry/vue'

import { saveCurrentPath } from '@/utils/storage/redirectPath'

import { userManager } from './oidcClient'
import { tokenService } from './tokenService'

let _isLoggingOut = false

export const isForceLoggingOut = () => _isLoggingOut

export const forceLogout = async (options?: { saveRedirectPath?: boolean }) => {
  if (_isLoggingOut) {
    return
  }
  _isLoggingOut = true

  if (options?.saveRedirectPath) {
    saveCurrentPath(true)
  }
  tokenService.clearTokens()
  await userManager.removeUser()
  Sentry.setUser(null)
  window.location.href = '/login'
}
